import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import '../asset/RoadShow.css'

function RoadShow() {
  const missionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (missionRef.current) {
      observer.observe(missionRef.current);
    }
  }, [missionRef]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  };

  const data = [
    {
      "place": "Town Square",
      "date": "Dubai, UAE",
      "area": "1200 sq ft",
      "rooms": 3,
      "bathroom": 2,
      "price": 75000,
      "imgUrl": "https://www.aredxb.com/images/areas/town-square.webp",
    },
    {
      "place": "Trade Center 1",
      "date": "Dubai, UAE",
      "area": "1500 sq ft",
      "rooms": 5,
      "bathroom": 3,
      "price": 150000,
      "imgUrl": "https://www.aredxb.com/images/areas/trade-center-1.webp",
    },
    {
      "place": "Tila Al Ghaf",
      "date": "Dubai, UAE",
      "area": "320 sq ft",
      "rooms": 3,
      "bathroom": 2,
      "price": 45000,
      "imgUrl": "https://www.aredxb.com/images/areas/tilal-al-ghaf.webp",
    },
    {
      "place": "City Walk",
      "date": "Dubai, UAE",
      "area": "320 sq ft",
      "rooms": 3,
      "bathroom": 2,
      "price": 45000,
      "imgUrl": "https://www.killadesign.com/wp-content/uploads/2021/02/Killa-Design-Project-City-Walk-Dubai-3.jpg",
    },
    {
      "place": "Dubai Harbour",
      "date": "Dubai, UAE",
      "area": "1200 sq ft",
      "rooms": 3,
      "bathroom": 2,
      "price": 75000,
      "imgUrl": "https://lh3.googleusercontent.com/p/AF1QipPZ0nnYXVtUPr8PwitQ4zxJOB6Co_X5ZbZcOTHb=s1360-w1360-h1020",
    },
    {
      "place": "JVC Dubai",
      "date": "Dubai, UAE",
      "area": "1200 sq ft",
      "rooms": 3,
      "bathroom": 2,
      "price": 75000,
      "imgUrl": "https://dt7j04u1665qi.cloudfront.net/JVC_dubai.webp",
    }
  ]

  const Card = ({ place, date, imgUrl }) => (
    <div className={`px-2 py-3 ${isVisible ? 'animate-slideInTop2 opacity-100' : 'opacity-0'}`}>
      <div className="bg-white rounded-lg shadow-sm overflow-hidden cursor-pointer transition-transform duration-250 ease-in-out hover:transform hover:-translate-y-1 hover:shadow-md border border-gray-100">
        <div className="h-44 sm:h-52 md:h-60 w-full overflow-hidden bg-gray-100">
          <img
            src={imgUrl}
            loading="lazy"
            alt={place}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="p-4">
          <h2 className="text-base sm:text-lg font-bold text-gray-900 tracking-wider">{place}</h2>
          <p className="text-xs sm:text-sm text-gray-500 mt-1">{date}</p>
        </div>
      </div>
    </div>
  );

  return (
    <div ref={missionRef} className='w-full py-12 sm:py-16 md:py-20 overflow-hidden'>
      <div className="px-4 sm:px-6 md:px-8 mid-lg:px-16 lg:px-24">
        <h1 className={`text-2xl sm:text-3xl lg:text-4xl font-light tracking-wider mb-4 ${isVisible ? 'animate-slideInLeft opacity-100' : 'opacity-0'}`}>
          PROMINENT AREAS IN DUBAI
        </h1>
        <p className={`mb-8 max-w-2xl tracking-wide text-xs sm:text-sm md:text-base text-gray-600 leading-relaxed transition-all duration-1000 ${isVisible ? 'animate-slideInRight opacity-100' : 'opacity-0'}`}>
          Discover your ideal residence in Dubai amidst the highly desirable communities, ranging from the iconic Downtown to the luxurious Palm Jumeirah. Explore the finest locales for purchasing property in Dubai and find your dream home today.
        </p>
        <Slider {...settings} className="slick-carousel slick-carousel-1">
          {data.map((card, it) => (
            <Card
              key={it}
              place={card.place}
              date={card.date}
              imgUrl={card.imgUrl}
            />
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default RoadShow;
